import { syncDocumentThemesFromStorage } from './theme/syncDocumentThemes.js';
import { startAppBootstrapPrefetch } from './hooks/appBootstrapPrefetch.js';
import './styles/style.css';

syncDocumentThemesFromStorage();
void startAppBootstrapPrefetch();
void import('./mountApp.js').then((module) => module.mountApp());
